import theme from '@styles/theme';
export default {
  container: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    overflow: 'hidden',
    p: '0 1px',
    pb: [0, 0, 'calc(50% - 2px)'],
    height: ['53.86667vw', '53.86667vw', 'auto']
  },
  button: (isButton: boolean) => ({
    cursor: isButton ? 'pointer' : 'unset',
    width: '100%',
    height: 'auto',
    p: 0,
    m: 0,
    outline: 'none',
    border: 0
  }),
  containerIcon: {
    position: 'absolute',
    display: 'flex',
    flexFlow: 'row no-wrap',
    alignItems: 'center',
    bottom: 20,
    right: ['unset', 20, 20],
    left: [20, 'unset', 'unset'],
    zIndex: theme.zIndex.documentHigh,
    color: theme.rawColors.neutralWhite,
    span: {
      svg: {
        mr: '8px',
        path: {
          fill: theme.rawColors.neutralWhite
        }
      }
    },
    text: {
      display: ['block', 'none', 'none']
    }
  },
  containerImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  shopTheLookSkeleton: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};